export const isEmployeeIdValid = (employeeId, setEmployeeIdError, setError) => {
  const noSpaceRegex = /^\S+$/;
  if (!employeeId.trim() || !noSpaceRegex.test(employeeId)) {
    if (setError) {
      setEmployeeIdError('Enter a valid Employee ID');
    }
    return false;
  }
  setEmployeeIdError('');
  return true;
};

export const isCompanyCodeValid = (companyCode, setCompanyCodeError, setError) => {
  const noSpaceRegex = /^\S+$/;
  if (!companyCode.trim() || !noSpaceRegex.test(companyCode)) {
    if (setError) {
      setCompanyCodeError('Enter a valid Company code');
    }

    return false;
  }
  setCompanyCodeError('');
  return true;
};

export const isLoyaltyCardNumberValid = (cardNumber, setCardNumberError, setError) => {
  if (!cardNumber || isNaN(cardNumber)) {
    if (setError) {
      setCardNumberError('Enter a valid loyalty card number');
    }

    return false;
  }
  setCardNumberError('');
  return true;
};

export const isCheckBoxChecked = (checkboxChecked, setCheckboxError, setError) => {
  if (!checkboxChecked) {
    if (setError) {
      setCheckboxError('Please agree to the terms and conditions.');
    }
    return false;
  }
  setCheckboxError('');
  return true;
};

export const isUserNameValid = (userName, setUserNameError, setError) => {
  if (!userName) {
    if (setError) {
      setUserNameError('Please enter username');
    }
    return false;
  }
  setUserNameError('');
  return true;
};

export const isPasswordValid = (password, setPasswordError, setError) => {
  if (!password) {
    if (setError) {
      setPasswordError('Please enter password');
    }
    return false;
  }
  setPasswordError('');
  return true;
};

export const isEmailIdValid = (emailId, setEmailIdError, setError) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailId || !emailRegex.test(emailId)) {
    if (setError) {
      setEmailIdError('Enter a valid email ID');
    }
    return false;
  }
  setEmailIdError('');
  return true;
};
